import { Box } from "@chakra-ui/react";
import { colors, Spacing } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";

import {
  FunnelCard,
  FunnelNoteBox,
  Highlight,
  NumberedStepHeading,
  Strong,
} from "../components/CostFunnelUI";

/**
 * Step 4 - 예상 음식 비용.
 *
 * 음식비 비중(파이 차트)과 "정해진 양 단위로만 추가 주문" 구조를 알려
 * 마지막 스텝(조문객 수 입력)의 필요성을 만든다.
 * 퍼센트 수치는 화면에 표기하지 않는다(디자인 의도).
 */
export default function Step4FoodCost() {
  return (
    <BaseStack width="100%">
      <NumberedStepHeading
        eyebrowStrong="예상 조문객 수"
        eyebrowRest="에 따른"
        index={2}
        title="음식 비용을 확인하세요"
      />

      <Spacing gap={18} />
      <FunnelCard>
        <Box className="body_14_r" color={colors.gray800}>
          음식비는 장례식장 비용의 <Strong>절반 가까이</Strong>를 차지해요.
        </Box>

        <Spacing gap={16} />
        <Box
          width="100%"
          background={colors.white}
          border={`1px solid ${colors.gray100}`}
          borderRadius="14px"
          padding="18px 16px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CostPieChart />
        </Box>

        <Spacing gap={14} />
        <Box className="body_14_r" color={colors.gray800}>
          음식은 조금씩 추가하는 게 아니라, <Strong>정해진 양만큼 추가 주문</Strong>해요.
          <br />
          <Highlight>그래서 예상 조문객 수에 맞는 음식비를 미리 확인하는 게 중요해요.</Highlight>
        </Box>
      </FunnelCard>

      <Spacing gap={18} />
      <FunnelNoteBox>
        음식 주문량을 어떻게 조절하느냐에 따라 비용이 <Strong>100만 원 이상</Strong> 차이 날 수도
        있어요.
      </FunnelNoteBox>
    </BaseStack>
  );
}

/**
 * 음식 55% / 빈소 30% / 제단꽃 15% 파이.
 *
 * 조각 위 라벨은 168x168 원 기준 절대 좌표라 원 크기를 바꾸면 라벨이 어긋난다.
 * 고정폭이지만 390px 프레임 안에서 좌우 여백이 충분해 좁은 기기에서도 넘치지 않는다.
 */
function CostPieChart() {
  return (
    <Box position="relative" width="168px" height="168px" flexShrink={0}>
      <Box
        position="absolute"
        inset={0}
        borderRadius="9999px"
        background={`conic-gradient(${colors.orange650} 0 55%, ${colors.gray500} 0 85%, ${colors.gray300} 0 100%)`}
      />
      <PieLabel left={125} top={91} className="subtitle_16_b" color={colors.white}>
        음식
      </PieLabel>
      <PieLabel left={44} top={97} className="subtitle_16_sb" color={colors.white}>
        빈소
      </PieLabel>
      <PieLabel left={59} top={36} className="subtitle_14_b" color={colors.gray700}>
        제단꽃
      </PieLabel>
    </Box>
  );
}

function PieLabel({
  left,
  top,
  className,
  color,
  children,
}: {
  left: number;
  top: number;
  className: string;
  color: string;
  children: string;
}) {
  return (
    <Box
      as="span"
      position="absolute"
      left={`${left}px`}
      top={`${top}px`}
      transform="translate(-50%, -50%)"
      whiteSpace="nowrap"
      className={className}
      color={color}
    >
      {children}
    </Box>
  );
}
